import { HttpErrorResponse } from "@angular/common/http";
import { LearnerEditDto } from "src/app/_models/LearnerEditDto";
import { LearnerList } from "src/app/_models/LearnerList";
import { Userprofile } from "src/app/_models/Userprofile";

export interface EditLearnerState {
  loading: boolean;
  error: HttpErrorResponse;
  result: LearnerList;
  data: Userprofile;
  dto: LearnerEditDto;
};

export const initialEditLearnerState: EditLearnerState = {
  loading: false,
  error: null,
  result: null,
  data: null,
  dto: null,
};